import React from 'react';
import { useSelector } from 'react-redux';

import { Post } from '../../components/Post';
import { sanitizePostContent } from '../../utils';
import { selectPostPreview } from '../../selectors/postPreview';
import { ERequestStatus } from '../../types/requestStatus';
import { EType } from '../../repositories/journal/entities/journal/JournalAttributesSchema';

export const PostPreviewContainer = () => {
  const postPreview = useSelector(selectPostPreview);

  if (postPreview.status !== ERequestStatus.Succeed) {
    return null;
  }

  const {
    attributes: { numViews, title, image, datePublish, subtitle, content, preparedContent, type },
  } = postPreview;

  return (
    <Post
      content={sanitizePostContent(preparedContent || content || '')}
      dateModified={datePublish}
      datePublished={datePublish}
      image={image}
      numViews={numViews}
      postId={0}
      postUrl={'/'}
      postCommentsUrl={'/'}
      subtitle={[EType.Articles, EType.News].includes(type) ? subtitle : undefined}
      title={title}
      type={type}
    />
  );
};
